import classNames from 'classnames';
import React from 'react';

type IProps = {
  name: string;
  checked: boolean;
  disabled: boolean;
  value: string;
  label: string;
  onChange: (value: string) => void;
};

const RadioButton: React.FC<IProps> = ({
  name,
  checked,
  disabled,
  value,
  onChange,
  label,
}) => {
  const labelClass = classNames([
    'bs-radio-wrapper',
    {
      'bs-radio-wrapper-disabled': disabled,
    },
  ]);

  const spanClass = classNames([
    'bs-radio',
    {
      'bs-radio-checked': checked,
      'bs-radio-disabled': disabled,
    },
  ]);

  return (
    <label htmlFor={name} className={labelClass}>
      <span className={spanClass}>
        <input
          id={name}
          type="radio"
          name={name}
          checked={checked}
          disabled={disabled}
          className="bs-radio-input"
          value={value}
          onChange={() => onChange(value)}
        />
        <span className="bs-radio-inner" />
      </span>
      <span className="radio-input-label">{label}</span>
    </label>
  );
};

export default RadioButton;
